import * as React from 'react'
import Error, { TYPES } from 'components/Error'
import { log } from 'utils/logger'
import { useLocation } from 'react-router-dom'

function withLocation(Component) {
  return function WrappedComponent(props) {
    const location = useLocation()
    return <Component {...props} location={location} />
  }
}

class PageErrorCatcher extends React.Component {
  constructor() {
    super()
    this.state = {
      hasError: undefined,
    }
  }

  static getDerivedStateFromError(error) {
    switch (error.message) {
      case TYPES.RESOURCE_NOT_FOUND:
        return { hasError: TYPES.RESOURCE_NOT_FOUND }
      case TYPES.NOT_FOUND:
        return { hasError: TYPES.NOT_FOUND }
      case TYPES.USER_DISABLED:
        return { hasError: TYPES.USER_DISABLED }
      case TYPES.NOT_LOGGED_IN:
        return { hasError: TYPES.NOT_LOGGED_IN }
      default:
        return { hasError: TYPES.ERROR }
    }
  }

  componentDidCatch(error) {
    if (![TYPES.RESOURCE_NOT_FOUND, TYPES.NOT_FOUND].includes(error.message)) {
      log.fatal(error)
    }
  }

  componentDidUpdate(prevProps) {
    const { location: prevLocation } = prevProps
    const { location } = this.props
    if (location.key !== prevLocation.key) {
      this.setState({ hasError: undefined })
    }
  }

  render() {
    const { children, isRoot } = this.props
    const { hasError } = this.state
    return hasError ? isRoot ? <Error.Root type={hasError} /> : <Error.Page type={hasError} /> : children
  }
}

class LocalErrorCatcher extends PageErrorCatcher {
  componentDidUpdate(prevProps) {
    const { data: prevData } = prevProps
    const { data, error } = this.props
    if (!error && JSON.stringify(prevData) !== JSON.stringify(data)) {
      this.setState({ hasError: undefined })
    }
  }

  render() {
    const { children, retry } = this.props
    const { hasError } = this.state
    return hasError ? <Error type={hasError} retry={retry} /> : children
  }
}

export const ErrorCatcher = withLocation(LocalErrorCatcher)

export default withLocation(PageErrorCatcher)
